import { Table, TableScrollContainer } from "@mantine/core";
import dayjs from "dayjs";
import { Link } from "react-router-dom";
import { dateFormat } from "../../../utils/dateFormat";

const AttentionTable = ({ items }) => {
  const rows = items?.map((item) => (
    <Table.Tr key={item.id}>
      <Table.Td>{item?.name}</Table.Td>
      <Table.Td>{dayjs(item?.dueDate).format(dateFormat)}</Table.Td>
      <Table.Td style={{ width: 130 }}>
        <Link
          target="_blank"
          to={`/reports-for-monitoring/flag-details/${item.id}`}
        >
          {`Open case #${item.id}`}
        </Link>
      </Table.Td>
    </Table.Tr>
  ));

  return (
    <TableScrollContainer maxHeight={125}>
      <Table
        stickyHeader
        styles={(theme) => ({
          td: { padding: 2 },
          tr: { border: "none" },
          th: {
            borderBottom: "2px solid #9A9A9A",
            padding: 2,
            backgroundColor: theme.colors.gray[1],
          },
        })}
      >
        <Table.Thead>
          <Table.Tr>
            <Table.Th>Name</Table.Th>
            <Table.Th>Date</Table.Th>
            <Table.Th>Link</Table.Th>
          </Table.Tr>
        </Table.Thead>
        <Table.Tbody>{rows}</Table.Tbody>
      </Table>
    </TableScrollContainer>
  );
};

export default AttentionTable;
